import React from "react";
import Home from "../Components/HomePage/Home";

const App: React.FC = () => {
  return <Home />;
};

export default App;
